import isNil from 'lodash/isNil';

// visible for tests
export const getEarliestDate = (
	currentDate: number | undefined | null,
	newDate: number | undefined | null,
) => {
	if (isNil(currentDate)) return newDate;
	if (isNil(newDate)) return currentDate;

	return Math.min(currentDate, newDate);
};

// visible for tests
export const getLatestDate = (
	currentDate: number | undefined | null,
	newDate: number | undefined | null,
) => {
	if (isNil(currentDate)) return newDate;
	if (isNil(newDate)) return currentDate;

	return Math.max(currentDate, newDate);
};

// visible for tests
export const getSum = (
	currentValue: number | undefined | null,
	newValue: number | undefined | null,
) => {
	if (isNil(currentValue) && isNil(newValue)) {
		return undefined;
	}
	return (currentValue ?? 0) + (newValue ?? 0);
};

const noop = () => undefined;

export const aggregateFunc = {
	EARLIEST: getEarliestDate,
	LATEST: getLatestDate,
	SUM: getSum,
	LIST_ALL: noop,
};
